export default __webpack_public_path__ + "static/media/IMG_20190721_111612.ad1cb0df.jpg";